import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { deselectVehicle } from 'state/actions/players_matching'
import { sortVehicles } from 'helpers/vehicles'

import KineticScrolling from 'components/KineticScrolling/KineticScrolling'
import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'
import { VehiclePropTypes } from 'containers/BattleRooms/propTypes'

import Vehicle from '../Vehicle/Vehicle'
import { REMOVE_VEHICLE_TOOLTIP } from '../Vehicle/constants'

import styles from './VehiclesCarousel.scss'

const MAX_VEHICLES_WITHOUT_ARROWS = 6

export class VehiclesCarousel extends React.Component {
    static propTypes = {
        deselectVehicle: PropTypes.func.isRequired,
        realm: PropTypes.string.isRequired,
        vehicleLevel: PropTypes.number.isRequired,
        vehicles: PropTypes.arrayOf(VehiclePropTypes).isRequired,
    }

    static defaultProps = { vehicles: [] }

    componentWillReceiveProps(props) {
        if (!this._scroll) return
        if (this.props.vehicleLevel !== props.vehicleLevel) this._scroll.scrollToItem(0)
    }

    render() {
        const sortedVehicles = sortVehicles(
            [...this.props.vehicles],
            'nation',
            this.props.realm
        )

        let vehicleNodes = sortedVehicles.map(vehicle => (
            <div key={vehicle.id} className={styles.item}>
                <Vehicle
                    vehicle={vehicle}
                    onClose={() => this.props.deselectVehicle(vehicle.id)}
                />
            </div>
        ))

        if (this.props.vehicles.length > MAX_VEHICLES_WITHOUT_ARROWS) {
            vehicleNodes = (
                <KineticScrolling snap={160} ref={c => this._scroll = c}>
                    {vehicleNodes}
                </KineticScrolling>
            )
        }

        return (
            <div className={styles.base}>
                {vehicleNodes}
                <DefaultTooltip {...REMOVE_VEHICLE_TOOLTIP} />
            </div>
        )
    }
}

export const mapStateToProps = ({ players_matching, settings }) => {
    const isSelected = (vehicle) => players_matching.selected_vehicle_cds.includes(vehicle.id)
    const vehicles = players_matching.vehicles.filter(isSelected)

    return {
        vehicles,
        realm: settings.realm,
        vehicleLevel: players_matching.vehicle_level,
    }
}

export const mapDispatchToProps = { deselectVehicle }

export default connect(mapStateToProps, mapDispatchToProps)(VehiclesCarousel)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/VehiclesCarousel/VehiclesCarousel.jsx